import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastUIComponent } from './toast.component';
import { ToastService } from './toast.service';

/**
 * The single overlay-hosted stack every toast renders into. Attached lazily by
 * `ToastService` and never used directly by callers.
 */
@Component({
  selector: 'fr8bot-ui-toast-container',
  imports: [ToastUIComponent],
  template: `
    @for (toast of toasts(); track toast.id) {
      <fr8bot-ui-toast
        [type]="toast.type"
        [title]="toast.title"
        [message]="toast.message"
        (dismiss)="dismiss(toast.id)"
        (mouseenter)="hold(toast.id)"
        (mouseleave)="release(toast.id)"
      />
    }
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerUIComponent {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts;

  protected dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  protected hold(id: number): void {
    this.toastService.holdTimer(id);
  }

  protected release(id: number): void {
    this.toastService.releaseTimer(id);
  }
}
